// Full library of taglines from the brief — sampled randomly so the hero never feels repetitive.
export const HERO_QUOTES = [
  "For Those Who Don't Gamble With Wealth, There's Zelo.",
  "We Unlock a Billion-Rupee Secret: Corporates Pay Your EMI.",
  "We Turn Rent Agreements into Wealth Blueprints.",
  "Zelo is What HNIs Buy When They're Done with Risks.",
  "The Brands You Know. Now Paying You Rent.",
  "Buy What the Top 0.1% Don't Talk About.",
  "Cashflow Is King. We Sell Crowns.",
  "Skip the Broker. Skip the Builder. Start with Rent.",
  "Predictable Income in an Unpredictable World.",
  "When It's Not About Returns. It's About Reliability.",
  "Because Waiting for Tenants is for Landlords. Not Investors.",
  "Markets Crash. EMIs Stay. Zelo Pays.",
  "The Wealthy Don't Buy Real Estate. They Buy Yield.",
  "Wealth Loves Certainty. So We Built It.",
  "Serious Assets for Serious Capital.",
  "Built for NRIs Who Want India Exposure Without the India Stress.",
  "Zelo Is What Happens When Real Estate Gets an Upgrade.",
  "Built for People Who Want Returns. Not Responsibility.",
  "Zelo Doesn't List Assets. We List Outcomes.",
  "Who Pays First: You or the Tenant?",
  "The Costliest Part of Real Estate? Waiting for Rent to Begin.",
  "Vacant Space Looks Great on Paper. Not So Much on Bank Statements.",
  "You Waited 24 Months for Possession. Then 6 More for a Tenant.",
  "Possession Letters Don't Pay EMIs. Rent Agreements Do.",
  "Not All Real Estate Pays Like This.",
  "Properties That Work as Hard as You Do.",
  "Your Money Didn't Come This Far to Wait Another Year.",
  "Forget the Hunt. Just Collect the Rent.",
  "In Real Estate, It's Not Bricks That Break You. It's the Gaps Between Tenants.",
  "No More 'Let's See What Happens After Possession.'",
  "Rent is the Only Metric That Matters.",
  "Real Estate with No Incoming Rent is Just A Liability.",
  "High-Conviction Assets. Zero Surprises.",
  "This Isn't a Platform. It's a Smarter Way to Own the India You See Around You.",
  "Zelo is How the Quietly Wealthy Buy Real Estate.",
  "Want to Know How the 1% Buy Real Estate? They Buy It Pre-Rented.",
  "Before You Buy Another Showroom, Ask: Who's Paying Me to Own This?",
  "Sleep Peacefully. Your Tenant is Paying On Time.",
  "We Don't Sell Dreams. We Sell Signed Rent Agreements.",
  "Your Money Should Work Like a Corporate Lease — Steady, Long-Term, Unbothered.",
  "Every Property on Zelo Has One Job: Pay You.",
  "This is How India's Rich Get Richer — Without Playing the Market.",
  "India's Most Underrated Asset Class. Until Now.",
  "Commercial Real Estate. But Pre-Installed.",
  "Not All Properties Are Investments. Zelo's Are.",
  "If It's Not Leased, It's Not on Zelo.",
  "Designed for the Top 1%. Just Like You.",
  "Due Diligence is Done. Tenant is In. Rent is Flowing.",
  "Every Asset We List is Already Someone's Expense. Make It Your Income.",
  "The Asset Class India Forgot. Zelo Didn't.",
  "India's Smartest Real Estate Platform Has No Empty Floors.",
  "This is Not Real Estate. This is Infrastructure for Your Passive Income.",
  "India's Finest Leased Assets. Built for Capital, Not Confusion.",
  "Pre-Leased Assets That Work for You, Not the Other Way Around.",
  "Own the Store, Not the Headaches.",
  "Shift Your Mindset From Property Hunting to Rent Collecting.",
  "Long-Term Corporate Leases. Locked-In Cashflow. No Surprises.",
  "Income Today. Exit Upside Tomorrow.",
  "Fully Documented. Fully Leased. Fully Yours.",
  "Because ROI Doesn't Care How Good the Brochure Looks.",
  "Pre-Leased, Curated, and Cash-Generating From Day Zero.",
  "Zelo Brings You Income-Backed Certainty in a World Full of Noise.",
  "Institutional-Grade Income. Individual Access.",
  "Zelo Skips the Wait, the Hassle, and the What-Ifs.",
  "You're Not Buying Bricks. You're Buying Performance.",
  "Everything Vetted. Everything Signed. Everything Rent-Ready.",
  "Zelo Assets Are Pre-Leased, Pre-Verified, and Pre-Paying.",
  "Assets Designed for Funds. Now Curated for Individuals.",
  "Every Zelo Deal Delivers Rent From Day 1. Or It Doesn't Get Listed.",
  "Your Capital Deserves Cashflow, Not Construction Delays.",
  "Verified Tenants. Locked Leases. Intelligent Investing.",
  "Zelo Makes Commercial Leasing a Product. Not a Process.",
  "Rental-First Investing. Predictable Income. Locked-In Upside.",
  "Not Listings. Not Promises. Only Pre-Leased, Rent-Yielding Assets.",
  "Ready-to-Earn Properties With Blue-Chip Tenants and Signed Leases.",
  "Curated Commercial Assets That Compound While You Live.",
  "Pre-Leased to Brands. Locked-In Income. Zero Guesswork.",
  "Locked-In Leases. Verified Tenants. Pre-Loaded Income.",
  "No Builder Calls. No Follow-ups. Just Monthly Rent in Your Account.",
  "Monthly Rental Income From India's Most Stable Commercial Tenants.",
  "Pre-Leased, Brand-Occupied. Cashflow Starts From Day 1.",
  "Institutional-Grade Leased Assets, Quietly Powering Real Wealth.",
  "Brand-Tenanted Assets That Send Rent Before You Sip Your Chai.",
  "Every Listing is a Financial Product — Not Just a Property.",
  "Because the Best-Performing Assets Don't Make Noise.",
  "Welcome to Zelo — the Anti-Speculation Platform.",
  "Own the Deal Behind the Brand — McDonald's, Joyalukkas, Westside.",
  "Every Zelo Asset Is Tenant-Occupied and Income-Ready.",
  "Curated. Contracted. Cash-Flowing.",
  "The Only Thing You Own That Pays You Before You Wake Up.",
  "Wealth Doesn't Speculate. It Subscribes — to Rent.",
  "Stop Buying Square Feet. Start Buying Cashflow.",
  "Boring Looking. Beautifully Performing.",
  "When the Brochure Stops Mattering, Zelo Starts.",
  "Most Real Estate Tells a Story. Zelo Hands You a Bank Statement.",
  "The Quiet Compounding Engine for Indian Wealth.",
  "Commercial Real Estate That Behaves Like a Corporate Bond.",
  "An Income Stream Wearing the Costume of a Building.",
  "Less FOMO. More EMI Coverage.",
  "Built for the Investor Who Reads the Lease Before the Brochure.",
  "The Calmest Asset Class You Haven't Bought Yet.",
  "Earn Rent Today. Realise Capital Gains Tomorrow.",
];

export const HERO_NOUN = "A property already rented out, generating rental income from day one.";
